import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import StartPage from './pages/StartPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import CheckinPage from './pages/CheckinPage';
import CheckoutPage from './pages/CheckoutPage';
import PointsPage from './pages/PointsPage';
import OrderPage from './pages/OrderPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import CheckinSuccessPage from './pages/CheckinSuccessPage';
import OrderDetailPage from './pages/OrderDetailPage';
import OrderSummaryPage from './pages/OrderSummaryPage';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Lấy store_id từ URL query params
    const searchParams = new URLSearchParams(location.search);
    const storeId = searchParams.get('store_id');
    
    // Nếu có store_id trong URL, lưu vào localStorage
    if (storeId) {
      localStorage.setItem('store_id', storeId);
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<StartPage onNavigate={path => window.location.href = path} />} />
      <Route path="/login" element={<LoginPage onNavigate={path => window.location.href = path} />} />
      <Route path="/register" element={<RegisterPage onNavigate={path => window.location.href = path} />} />
      <Route path="/change-password" element={<ChangePasswordPage onNavigate={path => window.location.href = path} />} />
      <Route path="/checkin" element={<CheckinPage onNavigate={path => window.location.href = path} />} />
      <Route path="/checkout" element={<CheckoutPage onNavigate={path => window.location.href = path} />} />
      <Route path="/points" element={<PointsPage onNavigate={path => window.location.href = path} />} />
      <Route path="/order" element={<OrderPage onNavigate={path => window.location.href = path} />} />
      <Route path="/order-history" element={<OrderHistoryPage onNavigate={path => window.location.href = path} />} />
      <Route path="/checkin-success" element={<CheckinSuccessPage onNavigate={path => window.location.href = path} />} />
      <Route path="/order-detail/:id" element={<OrderDetailPage onNavigate={path => window.location.href = path} />} />
      <Route path="/order-summary" element={<OrderSummaryPage onNavigate={path => window.location.href = path} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
